/**
 * **********************************************************************************************
 * Title service file
 * 
 * Defines the various titles or texts  that needs to be displayed on hover of buttons or labels
 * **********************************************************************************************
 */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  /* constructor */
  constructor() { }

  editIcon = "Edit";
  deleteIcon = "Delete";
  saveIcon = "Save";
  cancelIcon = "Cancel";
  plusIcon = "Expand";
  minusIcon = "Minimize";
  expandTitle = "Expand";
  collapseTitle = "Collapse";
  refreshIcon = "Refresh"
  expandIcon = "Expand";
  collapseIcon = "Collapse";
  commingSoon = "Coming Soon";
  activeTool = "Tool is active";
  openInNewIcon = "Open GitHub action";
  noURLFound = "No url found";
}
